app.controller("AgentSearchResultsController",
	["$scope", "$http", "AgentSearchModel", function($scope, $http, AgentSearchModel) {
		$scope.manyresults = false;
		$scope.model = AgentSearchModel;

		$scope.LoadMore = function() {
			$scope.model.searchResults = $scope.model.matches.slice(0,$scope.model.searchResults.length+30);
		};
	}]
);